// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import {getStorage } from 'firebase/storage'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDX4tbT1Yct4j4cRk2af6xUHB0C6UR-Iew",
  authDomain: "sg-ms-resource.firebaseapp.com",
  projectId: "sg-ms-resource",
  storageBucket: "sg-ms-resource.appspot.com",
  messagingSenderId: "85516209449",
  appId: "1:85516209449:web:4aed76f6b69c8dc99dbb38",
  measurementId: "G-V27192YYT7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const storage = getStorage(app)
export {
    storage
}